import { createFileRoute } from "@tanstack/react-router";
import { ensureList } from "@/features/sourcing/stage";
import { ListPage } from "@/features/sourcing/ListPage";

interface ListSearchParams {
  /** Selected saved view. */
  viewId?: string;
}

export const Route = createFileRoute("/_auth/_agents/sourcing/$listId")({
  validateSearch: (search: Record<string, unknown>): ListSearchParams => ({
    viewId: typeof search.viewId === "string" ? search.viewId : undefined,
  }),
  beforeLoad: ({ context, params, preload }) =>
    ensureList(context.queryClient, params.listId, preload),
  component: ListDetailPage,
});

function ListDetailPage() {
  const { listId } = Route.useParams();
  const { viewId } = Route.useSearch();
  return <ListPage listId={listId} viewId={viewId} />;
}
